import React, { useEffect, useState } from "react";
import Companydetails from "../../Details/Companydetails/Companydetails";


export default function Companydetailsform() {

    const [companysubmit, setCompanysubmit] = useState(false)

    const [bussinesstype, setBussinesstype] = useState("Choose One")

    function nexttab(){
        document.getElementById("billing-tab")?.click()
        window.scrollTo(0, 0);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        
    })

    return (
        <>

            {/* Company details form start */}

            {companysubmit === false ? <div>
                <div className="d-flex justify-content-between createaccountpage_content_header_container">
                    <div>
                        <div className="createaccountpage_content_header">
                            Company Details
                        </div>
                        <div className="createaccountpage_content_text">
                            Show details of your business data
                        </div>
                    </div>
                    <div>
                        <div className="createaccountpage_content_circle_wrap">
                            <div className="createaccountpage_content_circle">
                                <div className="createaccountpage_content_mask createaccountpage_content_half">
                                    <div className="createaccountpage_content_fill">
                                    </div>
                                </div>
                                <div className="createaccountpage_content_mask createaccountpage_content_full">
                                    <div className="createaccountpage_content_fill">
                                    </div>
                                </div>
                                <div className="inside-circle">1 of 3</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#businessinfo" aria-expanded="true" aria-controls="businessinfo">
                        Business Information
                    </button>
                    <div id="businessinfo" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">
                        <form>
                            <div className="createaccountpage_content_form">
                                <label htmlFor="dropdown" className="createaccountpage_content_form_label">Type of Business</label>
                                <div className="dropdown">
                                    <button className="dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        {bussinesstype}
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><div className="dropdown-item" onClick={() => setBussinesstype("Retailer")}>Retailer</div></li>
                                        <li><div className="dropdown-item" onClick={() => setBussinesstype("Distributor")}>Distributor</div></li>
                                        <li><div className="dropdown-item" onClick={() => setBussinesstype("Online Retailer")}>Online Retailer</div></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="createaccountpage_content_form">
                                <label htmlFor="Website" className="createaccountpage_content_form_label">Website</label>
                                <input type="text" placeholder="www.domain.com" className="createaccountpage_content_form_input" name="Website" id="Website" />
                            </div>
                        </form>
                    </div>

                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#sellto" aria-expanded="true" aria-controls="sellto">
                        Sell to
                    </button>
                    <div id="sellto" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">
                        <form>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="businessname" className="createaccountpage_content_form_label">Business Name</label>
                                <input type="text" placeholder="name of your company" className="createaccountpage_content_form_input" name="businessname" id="businessname" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="address_one" className="createaccountpage_content_form_label">Address 1</label>
                                <input type="text" placeholder="street, number, and building name" className="createaccountpage_content_form_input" name="address_one" id="address_one" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="address_two" className="createaccountpage_content_form_label">Address 2</label>
                                <input type="text" placeholder="street, number, and building name" className="createaccountpage_content_form_input" name="address_two" id="address_two" />
                            </div>

                            <div className="createaccountpage_content_form createaccountpage_content_form_address pe-0">

                                <div className="d-flex">
                                    <label htmlFor="city" className="createaccountpage_content_form_label createaccountpage_content_form_label">city</label>
                                    <input type="text" placeholder="city name" className="createaccountpage_content_form_input createaccountpage_content_form_input_address" id="city" name="city" />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="state" className="createaccountpage_content_form_label createaccountpage_content_form_label_address">State</label>
                                    <input type="text" placeholder="state name" className="createaccountpage_content_form_input createaccountpage_content_form_input_state" id="state" name="state" />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="selltoCountry" className="createaccountpage_content_form_label createaccountpage_content_form_label_address">Country</label>
                                    <input type="text" placeholder="country name" className="createaccountpage_content_form_input createaccountpage_content_form_input_address" id="selltoCountry" name="selltoCountry" />
                                </div>
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="zipcode" className="createaccountpage_content_form_label">Postal Code</label>
                                <input type="text" placeholder="zip code" className="createaccountpage_content_form_input" id="zipcode" name="zipcode" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="phonenumber" className="createaccountpage_content_form_label">Phone</label>
                                <input type="text" placeholder="phone number start with your country code" className="createaccountpage_content_form_input" id="phonenumber" name="phonenumber" />
                            </div>

                        </form>
                    </div>

                </div>

                <div className="createaccountpage_content_save_next_bottom">
                    <button type="button" className="save_button" onClick={() => setCompanysubmit(true)}>Save</button>
                    <button className="next_button" onClick={() => nexttab()}>
                        Next
                    </button>
                    {/* <ul className="nav nav-tabs flex-column" id="myTab" role="tablist">
                        <div className="nav-item" role="presentation">
                            <button className="nav-link next_button" id="billing-tab" data-bs-toggle="tab" data-bs-target="#billing" type="button" role="tab" aria-controls="billing" aria-selected="false" onClick={() => setCompanysubmit("false")}>
                                Next
                            </button>
                        </div>
                    </ul> */}
                </div>

            </div> : <Companydetails />}

            {/* Company details form over */}
        </>
    )

}